module.exports = '0.0.1';



//////////////////
// WEBPACK FOOTER
// ./~/@google/maps/lib/version.js
// module id = 978
// module chunks = 0 1 13 14 15